import { Grid, HStack, VStack } from '@chakra-ui/react'
import { Array, Option } from 'effect'
import DetailDisclosurePopover from 'presentation/components/DetailDisclosurePopover'
import SkiptraceDetailDisclosure from 'presentation/screens/Plans/components/SkiptraceDetailDisclosure'
import { FeatureAvailability, PrimaryText, SecondaryText } from 'presentation/screens/Plans/PlanComparisonV2/PlanComparisonDetailed/components/common'
import { Fragment } from 'react'
import SkiptraceFeatureRowViewModel from './SkiptraceFeatureRowViewModel'

const SkiptraceFeatureRow = () => {
  const vm = SkiptraceFeatureRowViewModel.usePresenter()

  const getPopoverContentProps = ({
    hasBucketNote,
    hasRateLimitNote,
  }: {
    hasBucketNote: boolean
    hasRateLimitNote: boolean
  }) =>
    hasBucketNote || hasRateLimitNote
      ? { w: '200px' }
      : undefined

  return (
    <>
      {Array.map(vm, row => (
        <Grid
          key={row.rowTitle}
          gridTemplateColumns='subgrid'
          gridColumn='1 / -1'
        >
          <VStack
            py='3'
            px={{
              base: '3',
              dtSm: '4',
            }}
            spacing='1'
            align='flex-start'
          >
            <HStack>
              <PrimaryText>
                {row.rowTitle}
              </PrimaryText>
              {row.rowInfoText.pipe(
                Option.map(text => (
                  <DetailDisclosurePopover
                    key={`${row.rowTitle}-info`}
                    iconProps={{ color: 'graystrong.200' }}
                    popoverContentProps={{
                      w: '160px',
                      textAlign: 'center',
                    }}
                  >
                    {text}
                  </DetailDisclosurePopover>
                )),
                Option.getOrNull,
              )}
            </HStack>
            <SecondaryText>
              Instant access to - Land Lines : Cell Phones :
              Date of Birth : Possible Relatives
            </SecondaryText>
          </VStack>
          {Array.map(row.columns, (content, i) => (
            <VStack justify='center' spacing='1' key={`${row.rowTitle}-${i}`}>
              {content.pipe(
                Option.match({
                  onSome: value => (
                    <Fragment key={`${row.rowTitle}-${i}`}>
                      <HStack>
                        <PrimaryText>
                          {value.primaryText}
                        </PrimaryText>
                        <SkiptraceDetailDisclosure
                          propertyCount={value.popoverValue}
                          iconProps={{ color: 'neutral.500' }}
                          bucketNote={value.bucketNote.pipe(Option.getOrUndefined)}
                          rateLimitNote={value.rateLimitNote.pipe(Option.getOrUndefined)}
                          popoverContentProps={getPopoverContentProps({
                            hasBucketNote: value.bucketNote.pipe(Option.isSome),
                            hasRateLimitNote: value.rateLimitNote.pipe(Option.isSome),
                          })}
                        />
                      </HStack>
                      {value.secondaryText1.pipe(
                        Option.map(text => (
                          <SecondaryText key='secondary-1'>
                            {text}
                          </SecondaryText>
                        )),
                        Option.getOrNull,
                      )}
                      <SecondaryText>
                        {value.secondaryText2}
                      </SecondaryText>
                    </Fragment>
                  ),
                  onNone: () => (
                    <FeatureAvailability isAvailable={false} />
                  ),
                }),
              )}
            </VStack>
          ))}
        </Grid>
      ))}
    </>
  )
}

export default SkiptraceFeatureRow
